'use strict';

// dom
const {
	div, form, label, input, select, option, button
} = require('iblokz-snabbdom-helpers');

// lib
const {obj} = require('iblokz-data');
const formUtil = require('../../../../util/form');
const {fieldLabel, enumLabel} = require('../../../comp/form/label');

module.exports = ({state, actions, i18n}) => {
	const doc = state.users.doc || {};
	const pageId = state.router.pageId;
	const ready = pageId === 'new' || doc._id === pageId;

	if (!ready) return '';

	const roles = Object.keys((i18n.enums && i18n.enums.role) || {user: 'User', admin: 'Admin'});
	const statuses = ['new', 'active', 'inactive'];

	return form(pageId === 'new' ? '.create' : '.edit', {
		on: {
			submit: ev => {
				ev.preventDefault();
				let data = Object.assign({}, doc, formUtil.toData(ev.target));
				if (data.password !== '' && data.password === data.passwordConfirm) {
					data = obj.filter(data, key => !key.match('passwordConfirm'));
				} else {
					data = obj.filter(data, key => !key.match('password'));
				}
				actions.users.save(
					data,
					state.auth.token,
					() => actions.router.go('admin.users')
				);
			}
		}
	}, [
		div('.field', [
			label([fieldLabel(i18n, 'fullName'), ': ']),
			input('[type="text"][name="fullName"]', {props: {value: doc.fullName || ''}})
		]),
		div('.field', [
			label([fieldLabel(i18n, 'email'), ': ']),
			input('[type="email"][name="email"]', {props: {value: doc.email || ''}})
		]),
		div('.field', [
			label([fieldLabel(i18n, 'role'), ': ']),
			select('[name="role"]',
				{props: {value: doc.role || 'user'}},
				roles.map(role =>
					option(`[value="${role}"]`, {
						attrs: {selected: (doc.role || 'user') === role}
					}, enumLabel(i18n, 'role', role))
				)
			)
		]),
		div('.field', [
			label([fieldLabel(i18n, 'status'), ': ']),
			select('[name="status"]',
				{props: {value: doc.status || 'active'}},
				statuses.map(status =>
					option(`[value="${status}"]`, {
						attrs: {selected: (doc.status || 'active') === status}
					}, enumLabel(i18n, 'status', status))
				)
			)
		]),
		div('.field', [
			label([fieldLabel(i18n, 'password'), ': ']),
			input('[type="password"][name="password"][autocomplete="new-password"]')
		]),
		div('.field', [
			label([fieldLabel(i18n, 'passwordConfirm'), ': ']),
			input('[type="password"][name="passwordConfirm"][autocomplete="new-password"]')
		]),
		div('.buttons', [
			button('#edit-cancel.btn.btn-white[type="button"]', {
				on: {click: () => actions.router.go('admin.users')}
			}, i18n.common.actions.cancel),
			' ',
			button('#edit-save.btn.btn-primary[type="submit"]', i18n.common.actions.save)
		])
	]);
};
